import { apiRequest } from './client';
import type {
  JiraIntegrationStatus,
  JiraIssueSearchResponse,
  LinkedJiraIssue,
} from './types';

export const jira = {
  status: (organizationId: string) =>
    apiRequest<JiraIntegrationStatus>('/api/jira/integration', { organizationId }),

  // The backend mints the authorize URL with the OAuth state baked in; the frontend just
  // browser-navigates to it. We deliberately do not use fetch() to follow the redirect —
  // Atlassian's consent screen has to load in the user's tab.
  authorizeUrl: (organizationId: string) =>
    apiRequest<{ url: string }>('/api/jira/oauth/authorize-url', { organizationId }),

  disconnect: (organizationId: string) =>
    apiRequest<void>('/api/jira/integration', {
      method: 'DELETE',
      organizationId,
    }),

  search: (organizationId: string, query: string) =>
    apiRequest<JiraIssueSearchResponse>('/api/jira/issues/search', {
      organizationId,
      query: { query },
    }),

  listForAnalysis: (organizationId: string, analysisId: string) =>
    apiRequest<LinkedJiraIssue[]>(`/api/jira/analyses/${analysisId}/issues`, { organizationId }),

  link: (organizationId: string, analysisId: string, key: string) =>
    apiRequest<LinkedJiraIssue[]>(`/api/jira/analyses/${analysisId}/issues`, {
      method: 'POST',
      organizationId,
      body: { key },
    }),

  unlink: (organizationId: string, analysisId: string, key: string) =>
    apiRequest<LinkedJiraIssue[]>(
      `/api/jira/analyses/${analysisId}/issues/${encodeURIComponent(key)}`,
      { method: 'DELETE', organizationId },
    ),
};
